import { useState } from "react";
import { Link } from "react-router-dom";
import { Crown } from "lucide-react";
import { NAV } from "@/components/layout/Navbar";
import { IrieClubDialog } from "@/components/IrieClub";

export const SiteFooter = () => {
  const [club, setClub] = useState(false);
  return (
  <footer data-testid="site-footer" className="bg-[#0F172A] text-slate-400 border-t border-white/5">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="flex flex-wrap items-start justify-between gap-8">
        <div>
          <img src="/logo.png" alt="DhanTrove" className="h-9 w-auto" />
          <p className="mt-3 text-sm max-w-xs">India's comparison desk for mutual funds, insurance and stock brokers — powered by live AMFI & market data.</p>
        </div>
        <nav className="grid grid-cols-2 gap-x-10 gap-y-2 text-sm">
          {NAV.map((n) => <Link key={n.id} to={n.to} data-testid={`footer-link-${n.id}`} className="hover:text-white transition-colors">{n.label}</Link>)}
          <Link to="/join-partner" data-testid="footer-link-join" className="hover:text-white transition-colors">Join as Partner</Link>
          <button type="button" onClick={() => setClub(true)} data-testid="footer-link-irie-club" className="text-left inline-flex items-center gap-1.5 text-amber-300 hover:text-amber-200 font-semibold transition-colors"><Crown className="w-3.5 h-3.5" />IRIE Club</button>
        </nav>
      </div>
      <div className="mt-10 border-t border-white/10" />
      <p data-testid="compliance-disclaimer" className="mt-5 text-xs sm:text-sm leading-relaxed max-w-4xl">
        <strong className="text-slate-200">Regulatory Status &amp; Structural Declaration:</strong> DhanTrove.com is an independent financial
        information and comparison platform for retail investors in India. DhanTrove does not provide direct financial
        analysis, personalized investment recommendations, stock tips, or wealth management advice. DhanTrove never handles, holds, or processes
        direct retail customer transaction funds or capital deposits. All financial transactions and final agreements are processed independently
        by the user via the respective SEBI / AMFI / IRDAI licensed entities. Data shown is sourced from public disclosures and may be delayed; please verify with the provider before investing.
      </p>
      <p className="mt-6 text-xs text-slate-500">© {new Date().getFullYear()} DhanTrove.com · Data: AMFI India, NSE/BSE (via Yahoo Finance), IRDAI disclosures. Mutual fund investments are subject to market risks.</p>
    </div>
    <IrieClubDialog open={club} onClose={() => setClub(false)} />
  </footer>
  );
};
